// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Caml_array from "bs-platform/lib/es6/caml_array.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Dna$PhyloLibWeb from "./dna.bs.js";

function num_seq(msa) {
  return msa.length;
}

function seq_len(msa) {
  return Dna$PhyloLibWeb.length(Caml_array.caml_array_get(msa, 0));
}

function align(dnas) {
  return dnas;
}

function get_seq(i, msa) {
  return Caml_array.caml_array_get(msa, i);
}

function get_base(i, j, msa) {
  var c = Dna$PhyloLibWeb.get(Caml_array.caml_array_get(msa, i), j);
  if (c !== undefined) {
    return c;
  } else {
    return Pervasives.failwith("Index out of bounds");
  }
}

export {
  align ,
  num_seq ,
  seq_len ,
  get_seq ,
  get_base ,
  
}
/* No side effect */
